<div [className]="className" [style]="styleName">
<fieldset> 
      <legend [className]="labelClass" 
                 [style]="labelStyle"  
                 [translateParams]="labelParam" translate>
                 <span [innerHTML]="label|translate:labelParam"></span>
                 <ng-content></ng-content>
                 <div [hidden]="!error" class="sr-only">
                        <b>{{!error? '':'error.prefix'| translate}}</b>
                        <span  class="" [innerHTML]="error|translate:errorParam" ></span>
                 </div>
      </legend>

      <div *ngIf="hintText" [className]="hintClass"  [innerHTML]="hintText|translate:hintParam"
                                [style]="hintlStyle"></div>

      <div [className]="textClass" [style]="textStyle">
            
            <ng-select [(ng-model)]="DD" (change)="onDateChange()"  [alt-text]="tooltipDD"
                       [attr.disabled]="disable?true:null"  outer-class="no-margin"
                       [outer-class]="spaceBetween"         id="date_{{id}}"
                       [input-class]="inputClass" 
                       [input-style]="inputStyle"  
                       [item-list]="days" [placeholder]="'shared.select.abbr'|translate" translate>

                       <span [className]="headClass" 
                                 [style]="headStyle" translate='shared.date.day'></span>

            </ng-select>

            <ng-select [(ng-model)]="MM" (change)="onDateChange()" [alt-text]="tooltipMM"
                       [attr.disabled]="disable?true:null"  outer-class="no-margin"
                       [outer-class]="spaceBetween"
                       [input-class]="inputClass" 
                       [input-style]="inputStyle"  
                       [item-list]="months" translate>

                       <span [className]="headClass" 
                                 [style]="headStyle" translate='shared.date.month'></span>

            </ng-select>

            <ng-input  [(ng-model)]="YY"   [alt-text]="tooltipYY"
                       [attr.disabled]="disable?true:null"    outer-class="no-margin"
                       [outer-class]="spaceEnd"            option="8"
                       (input)="onDateChange()"
                       [input-class]="inputClass" 
                       [input-style]="inputStyle" 
                       type="number" size="4" translate>

                       <span [className]="headClass" 
                                 [style]="headStyle" translate='shared.date.year'></span>

            </ng-input>
      </div>
</fieldset>     
       <div [hidden]="!error" 
            [className]="errorClass"
            [style]="errorStyle">
              <b>{{!error? '':'error.prefix'| translate}}</b>
              <span class="" [innerHTML]="error|translate:errorParam" ></span>
       </div>
</div>



